import React, { useEffect, useRef, useState } from 'react';
import { Popup, Button } from 'devextreme-react';
import Form, { RequiredRule, GroupItem, Label, SimpleItem, AsyncRule, EmptyItem, StringLengthRule } from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import http from '../../utils/http';
import { cancelRegisterDialog } from '../../store/cancelRegister/cancelRegisterReducer';
import { useDispatch, useSelector } from 'react-redux';
import { categoriesDataSource, dataAccess, getPriceByCategory, resources } from '../../data/app';
import useAuthorization from '../../hooks/useAuthorization';
import { changeCategoryDialog } from '../../store/changeCategoryRegister/changeCategoryRegisterReducer';

const DialogChangeCategory = props => {   

    const { authorized } = useAuthorization([resources.matriculas, dataAccess.delete ]);

    const { changeCategory: {open, id, code, name, categories: currentCategories}, appInfo } = useSelector(store => store);  
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({ id:0, code: 0, name: '', categories: [], total:0 });

    const dispatch = useDispatch();
    const refForm = useRef();

    const closeDialog = (load) => {
        dispatch(changeCategoryDialog({ open: false, id: 0, code: 0, name: '', categories: [] }));

        if (load) {

            let { onChange } = props;
            onChange();

        }
    }

    const onHiding = ({ load }) => closeDialog(load);

    const changeCategory = (params) => {

        let result = refForm.current.instance.validate();

        if (result.isValid) {

            setLoading(true);

            http(`registers/${id}/change-category`).asPost(data)
                .then(resp => {

                    setLoading(false);
                    notify(`Categoria de la matricula ${id} cambiada correctamente`);
                    closeDialog(true);

                }).catch(err => {
                    setLoading(false);
                    notify(err, 'error');
                });;
        }
    }

    useEffect(() => {
        if(open && id > 0){
            setData({ id, code, name, categories: [...currentCategories.split(',').map(Number)] });
        }
        else
            setData({ id:0, code: 0, name: '', categories: [] });
    }, [open, currentCategories]);

    console.log({data});

    return authorized(
        <div className="">
            <Popup
                width={450}
                height={280}
                title="Confirmar"
                onHiding={onHiding}
                visible={open}
            >
                <h6>Cambio de categoria de la matricula {code}</h6>
                <div style={{ marginBottom: 10 }}>Nombre: <b>{name}</b></div>

                <Form formData={data} ref={refForm}>
                    <GroupItem colCount={6}>
                        <SimpleItem dataField="categories" colSpan={6} editorType='dxTagBox' editorOptions={{
                            dataSource: categoriesDataSource,
                            showSelectionControls: true,
                            onValueChanged: e => {
                                const categories = e.value || [];
                                console.log({categories});

                                const newSubTotal = getPriceByCategory(appInfo, categories);                               

                                setData(prev => {
                                    if (prev.total === newSubTotal) return prev; // 🔑 evita loop
                                    return { ...prev, total: newSubTotal };
                                });
                            }
                        }}>
                            <Label text="Categorias" />
                            <RequiredRule message="Seleccione las categorias" />
                        </SimpleItem> 
                    </GroupItem>
                </Form>
                <br />
                <div style={{ marginBottom: 10, fontSize: '16px' }}>Total: <b>{parseFloat(data.total).toFixed(2)}</b></div>
                <div>

                <Button
                    width={'100%'}
                    text={loading ? 'Cambiando...' : "Cambiar categoria"}
                    disabled={loading}
                    type="normal"
                    icon="save"
                    stylingMode="contained"
                    onClick={changeCategory}
                    />
                </div>
            </Popup>
        </div>
    );
}

export default DialogChangeCategory;